import {
  ENTITY_SELECTED,
  HAZARDS_FETCHED,
  HAZARD_REQUEST_STARTED,
  HAZARD_REQUEST_ERROR,
  ENTITY_DETAIL_FETCHED,
  ENTITY_DETAILS_REQUEST_STARTED,
  ENTITY_DETAILS_REQUEST_ERROR,
  DOT_FETCHED,
  DOT_REQUEST_STARTED,
  DOT_REQUEST_ERROR,
  WC_FETCHED,
  WC_REQUEST_STARTED,
  WC_REQUEST_ERROR,
  WELFARE_SUMMARIES_REQUEST_STARTED,
  WELFARE_SUMMARIES_FETCHED,
  WELFARE_SUMMARIES_REQUEST_ERROR,
  WELFARE_BROKER_SUMMARIES_REQUEST_STARTED,
  WELFARE_BROKER_SUMMARIES_FETCHED,
  WELFARE_BROKER_SUMMARIES_REQUEST_ERROR,
  WELFARE_BROKER_SUMMARIES_HISTORY_REQUEST_STARTED,
  WELFARE_BROKER_SUMMARIES_HISTORY_FETCHED,
  WELFARE_BROKER_SUMMARIES_HISTORY_REQUEST_ERROR,
  WELFARE_LOBS_REQUEST_STARTED,
  WELFARE_LOBS_REQUEST_ERROR,
  WELFARE_LOBS_FETCHED,
  WELFARE_SERVICE_PROVIDER_SUMMARIES_REQUEST_STARTED,
  WELFARE_SERVICE_PROVIDER_SUMMARIES_REQUEST_ERROR,
  WELFARE_SERVICE_PROVIDER_SUMMARIES_FETCHED,
  WELFARE_SERVICE_PROVIDERS_REQUEST_STARTED,
  WELFARE_SERVICE_PROVIDERS_REQUEST_ERROR,
  WELFARE_SERVICE_PROVIDERS_FETCHED,
  RETIREMENT_SUMMARIES_FETCHED,
  RETIREMENT_SUMMARIES_REQUEST_STARTED,
  RETIREMENT_SUMMARIES_REQUEST_ERROR,
  RETIREMENT_PLANS_FETCHED,
  RETIREMENT_PLANS_REQUEST_STARTED,
  RETIREMENT_PLANS_REQUEST_ERROR,
  RETIREMENT_PLANS_HISTORY_FETCHED,
  RETIREMENT_PLANS_HISTORY_REQUEST_STARTED,
  RETIREMENT_PLANS_HISTORY_REQUEST_ERROR,
  RETIREMENT_PROVIDER_SUMMARIES_FETCHED,
  RETIREMENT_PROVIDER_SUMMARIES_REQUEST_STARTED,
  RETIREMENT_PROVIDER_SUMMARIES_REQUEST_ERROR,
  RETIREMENT_SERVICE_PROVIDERS_FETCHED,
  RETIREMENT_SERVICE_PROVIDERS_REQUEST_STARTED,
  RETIREMENT_SERVICE_PROVIDERS_REQUEST_ERROR,
  OSHA_REPORT_FETCHED,
  OSHA_REPORT_REQUEST_STARTED,
  OSHA_REPORT_REQUEST_ERROR,
  WHD_REPORT_FETCHED,
  WHD_REPORT_REQUEST_STARTED,
  WHD_REPORT_REQUEST_ERROR,
  USER_NOTES_FETCHED,
  USER_NOTES_REQUEST_STARTED,
  USER_NOTES_REQUEST_ERROR,
  DUP_AMS_ACCOUNTS_FETCHED,
  DUP_AMS_ACCOUNTS_REQUEST_STARTED,
  DUP_AMS_ACCOUNTS_REQUEST_ERROR,
  LAUNCH_DARKLY_FETCHED,
  LAUNCH_DARKLY_REQUEST_STARTED,
  LAUNCH_DARKLY_REQUEST_ERROR,
} from '../actions/Actions';
import {
  PROPERTY_REPORT_FETCHED,
  PROPERTY_REPORT_REQUEST_STARTED,
  PROPERTY_REPORT_REQUEST_ERROR,
  FULL_PROPERTY_REPORT_FETCHED,
  FULL_PROPERTY_REPORT_REQUEST_STARTED,
  FULL_PROPERTY_REPORT_REQUEST_ERROR,
} from '../actions/PropertyActions';
import {
  CONTACTS_FETCHED,
  CONTACTS_REQUEST_STARTED,
  CONTACTS_REQUEST_ERROR,
} from '../actions/ContactsActions';
import {
  BROKERS_FETCHED,
  BROKERS_REQUEST_STARTED,
  BROKERS_REQUEST_ERROR,
} from '../actions/BrokersActions';
import {
  CARRIERS_FETCHED,
  CARRIERS_REQUEST_STARTED,
  CARRIERS_REQUEST_ERROR,
} from '../actions/CarriersActions';
import {
  WELFARE_FILINGS_FETCHED,
  WELFARE_FILINGS_REQUEST_ERROR,
  WELFARE_FILINGS_REQUEST_STARTED,
  RETIREMENT_FILINGS_FETCHED,
  RETIREMENT_FILINGS_REQUEST_ERROR,
  RETIREMENT_FILINGS_REQUEST_STARTED,
} from '../actions/FilingsActions';
// HELPERS
import { sumObjectArray } from '../../lib/Helper';
import {
  summarizeWelfareBusinessLinesToBrokers,
  summarizeWelfareBusinessLinesToCarriers,
  summarizeWelfareBusinessLinesToEmployers,
  summarizeWelfareBusinessLinesToLobs,
  summarizeWelfareServiceProvidersToProviders,
  summarizeWelfareServiceProvidersToEmployers,
  summarizeWelfareBusinessLinesToBrokersNormalized,
  summarizeWelfareBusinessLinesToCarriersNormalized,
} from '../../lib/WelfareApiHelpers';
import {
  summarizeRetirementPlansToSponsors,
  summarizeRetirementServiceProvidersToSponsors,
} from '../../lib/RetirementApiHelpers';
import Helper from '../../lib/Helper';

const getInitialState = () => {
  return {
    selectedEntity: null,
    // keep track of the last module to select an entity
    lastSelectedModule: null,
    //Entity Detail
    entityDetail: null,
    LoadingEntityDetail: false,
    ErrorLoadingEntityDetail: false,
    // Contacts
    contactReport: null,
    LoadingContacts: false,
    ErrorLoadingContacts: false,
    // Brokers
    top10BrokersReport: null,
    LoadingBrokers: false,
    ErrorLoadingBrokers: false,
    // Carriers
    top10CarriersReport: null,
    LoadingCarriers: false,
    ErrorLoadingCarriers: false,
    //HazardHub
    hazardHubReport: null,
    LoadingHazards: false,
    ErrorLoadingHazards: false,
    // DOT
    dotReport: null,
    LoadingDot: false,
    ErrorLoadingDot: false,
    // WC
    wcReport: null,
    LoadingWc: false,
    ErrorLoadingWc: false,
    // OSHA
    oshaReport: null,
    LoadingOsha: false,
    ErrorLoadingOsha: false,
    // Property
    propertyReport: null,
    LoadingProperty: false,
    ErrorLoadingProperty: false,
    // Full Property (unlimited)
    fullPropertyReport: null,
    LoadingFullProperty: false,
    ErrorLoadingFullProperty: false,
    // WHD
    whdReport: null,
    LoadingWhd: false,
    ErrorLoadingWhd: false,
    // Welfare Summaries
    welfareSummaries: null,
    LoadingWelfareSummaries: false,
    ErrorLoadingWelfareSummaries: false,
    // Welfare Broker Summaries
    welfareBrokerSummaries: null,
    LoadingWelfareBrokerSummaries: false,
    ErrorLoadingWelfareBrokerSummaries: false,
    // Welfare Broker Summaries History
    welfareBrokerSummariesHistory: null,
    LoadingWelfareBrokerSummariesHistory: false,
    ErrorLoadingWelfareBrokerSummariesHistory: false,
    // Welfare Lines of Business
    welfareLinesOfBusiness: null,
    welfareLinesOfBusinessReport: {},
    LoadingWelfareLinesOfBusiness: false,
    ErrorLoadingWelfareLinesOfBusiness: false,
    // Welfare Service PRovider Summaries
    welfareServiceProviderSummaries: null,
    LoadingWelfareServiceProviderSummaries: false,
    ErrorLoadingWelfareServiceProviderSummaries: false,
    // Welfare Service Providers
    welfareServiceProviders: null,
    LoadingWelfareServiceProviders: false,
    ErrorLoadingWelfareServiceProviders: false,
    // Retirement Summaries
    retirementSummaries: null,
    LoadingRetirementSummaries: false,
    ErrorLoadingRetirementSummaries: false,
    // Retirement Plans
    retirementPlans: null,
    LoadingRetirementPlans: false,
    ErrorLoadingRetirementPlans: false,
    // Retirement Plans History
    retirementPlansHistory: null,
    LoadingRetirementPlansHistory: false,
    ErrorLoadingRetirementPlansHistory: false,
    // Retirement Provider Summaries
    retirementProviderSummaries: null,
    LoadingRetirementProviderSummaries: false,
    ErrorLoadingRetirementProviderSummaries: false,
    // Retirement Service Providers
    retirementServiceProviders: null,
    LoadingRetirementServiceProviders: false,
    ErrorLoadingRetirementServiceProviders: false,
    // User notes
    userNotes: null,
    LoadingUserNotes: false,
    ErrorLoadingUserNotes: false,
    // Filings
    filingsReport: null,
    LoadingFilings: false,
    ErrorLoadingFilings: false,
    // welfare filings
    welfareFilingsReport: null,
    LoadingWelfareFilings: false,
    ErrorLoadingWelfareFilings: false,
    // Duplicated Ams Accounts
    dupAmsAccounts: null,
    LoadingDupAmsAccounts: false,
    ErrorLoadingDupAmsAccounts: false,
    // Launch Darkly Service
    launchDarkly: null,
    LoadingLaunchDarkly: false,
    ErrorLoadingLaunchDarkly: false,
  };
};

function EntityDetails(state = getInitialState(), action) {
  switch (action.type) {
    case ENTITY_SELECTED:
      return {
        ...state,
        selectedEntity: action.entity,
        lastSelectedModule: action.module,
      };
    case ENTITY_DETAILS_REQUEST_STARTED:
      return {
        ...state,
        LoadingEntityDetail: true,
        ErrorLoadingEntityDetail: false,
      };
    case ENTITY_DETAILS_REQUEST_ERROR:
      return {
        ...state,
        LoadingEntityDetail: false,
        ErrorLoadingEntityDetail: true,
      };
    case ENTITY_DETAIL_FETCHED:
      // if the muns of the returned entity details does not matche the
      // selected entity then do not update state
      if (
        action.entityDetail.entity.muns !== state.selectedEntity.muns &&
        action.entityDetail.muns_list.indexOf(state.selectedEntity.muns) === -1
      ) {
        return { ...state };
      }

      return {
        ...state,
        LoadingEntityDetail: false,
        ErrorLoadingEntityDetail: false,
        entityDetail: action.entityDetail,
      };
    case CONTACTS_REQUEST_STARTED:
      return {
        ...state,
        LoadingContacts: true,
        ErrorLoadingContacts: false,
      };
    case CONTACTS_REQUEST_ERROR:
      return {
        ...state,
        LoadingContacts: false,
        Error: true,
      };
    case CONTACTS_FETCHED:
      // We could get back a null for a company that has no WC data
      if (action.contacts === null || !action.contacts.contacts) {
        return {
          ...state,
          LoadingContacts: false,
          ErrorLoadingContacts: false,
          contactReport: {
            ...action.contacts,
          },
        };
      }
      // if the muns of the returned wc report does not match the
      // selected entity then do not update state
      if (action.contacts.muns && action.contacts.muns !== state.selectedEntity.muns) {
        return { ...state };
      }
      return {
        ...state,
        LoadingContacts: false,
        contactReport: {
          ...action.contacts,
          contactCount: action.contacts.contacts.length,
        },
      };
    case BROKERS_REQUEST_STARTED:
      return {
        ...state,
        LoadingBrokers: true,
        ErrorLoadingBrokers: false,
      };
    case BROKERS_REQUEST_ERROR:
      return {
        ...state,
        LoadingBrokers: false,
        Error: true,
      };
    case BROKERS_FETCHED:
      // We could get back a null for a company that has no top10BrokersReport data
      if (action.top10BrokersReport === null) {
        return {
          ...state,
          LoadingBrokers: false,
          ErrorLoadingBrokers: false,
          top10BrokersReport: {
            ...action.top10BrokersReport,
          },
        };
      }
      // if the muns of the returned wc report does not match the
      // selected entity then do not update state
      if (
        action.top10BrokersReport.muns &&
        action.top10BrokersReport.muns !== state.selectedEntity.muns
      ) {
        return { ...state };
      }
      return {
        ...state,
        LoadingBrokers: false,
        top10BrokersReport: {
          ...action.top10BrokersReport,
        },
      };
    case CARRIERS_REQUEST_STARTED:
      return {
        ...state,
        LoadingCarriers: true,
        ErrorLoadingCarriers: false,
      };
    case CARRIERS_REQUEST_ERROR:
      return {
        ...state,
        LoadingCarriers: false,
        Error: true,
      };
    case CARRIERS_FETCHED:
      // We could get back a null for a company that has no top10CarriersReport data
      if (action.top10CarriersReport === null) {
        return {
          ...state,
          LoadingCarriers: false,
          ErrorLoadingCarriers: false,
          top10CarriersReport: {
            ...action.top10CarriersReport,
          },
        };
      }
      // if the muns of the returned wc report does not match the
      // selected entity then do not update state
      if (
        action.top10CarriersReport.muns &&
        action.top10CarriersReport.muns !== state.selectedEntity.muns
      ) {
        return { ...state };
      }
      return {
        ...state,
        LoadingCarriers: false,
        top10CarriersReport: {
          ...action.top10CarriersReport,
        },
      };
    case HAZARD_REQUEST_STARTED:
      return {
        ...state,
        LoadingHazards: true,
        ErrorLoadingHazards: false,
      };
    case HAZARD_REQUEST_ERROR:
      return {
        ...state,
        LoadingHazards: false,
        ErrorLoadingHazards: true,
      };
    case HAZARDS_FETCHED:
      // If the fetched hazardReport is empty
      if (!action.hazardReport.lat || !action.hazardReport.lng) {
        return {
          ...state,
          LoadingHazards: false,
          hazardHubReport: action.hazardReport,
          ErrorLoadingHazards: false,
        };
      }

      // If the lat/lng of the fetched hazardReport does not match the selected
      // entity then do not update state with it.
      if (
        Helper.roundFloat(parseFloat(action.hazardReport.lat), 7) !==
          Helper.roundFloat(state.selectedEntity.latitude, 7) ||
        Helper.roundFloat(parseFloat(action.hazardReport.lng), 7) !==
          Helper.roundFloat(state.selectedEntity.longitude, 7)
      ) {
        return { ...state };
      }

      return {
        ...state,
        LoadingHazards: false,
        hazardHubReport: action.hazardReport,
        ErrorLoadingHazards: false,
      };
    case DOT_REQUEST_STARTED:
      return {
        ...state,
        LoadingDot: true,
        ErrorLoadingDot: false,
      };
    case DOT_REQUEST_ERROR:
      return {
        ...state,
        LoadingDot: false,
        ErrorLoadingDot: true,
      };
    case DOT_FETCHED:
      // We could get back a null for a company that has no DOT data
      if (action.dotReport === null) {
        return {
          ...state,
          LoadingDot: false,
          ErrorLoadingDot: false,
          dotReport: action.dotReport,
        };
      }
      // if the muns of the returned dot report does not match the
      // selected entity then do not update state
      if (action.dotReport.muns && action.dotReport.muns !== state.selectedEntity.muns) {
        return { ...state };
      }
      return {
        ...state,
        LoadingDot: false,
        dotReport: action.dotReport,
      };
    case WC_REQUEST_STARTED:
      return {
        ...state,
        LoadingWc: true,
        ErrorLoadingWc: false,
      };
    case WC_REQUEST_ERROR:
      return {
        ...state,
        LoadingWc: false,
        ErrorLoadingWc: true,
      };
    case WC_FETCHED:
      // We could get back a null for a company that has no WC data
      if (action.wcReport === null) {
        return {
          ...state,
          LoadingWc: false,
          ErrorLoadingWc: false,
          wcReport: action.wcReport,
        };
      }
      // if the muns of the returned wc report does not match the
      // selected entity then do not update state
      if (action.wcReport.muns && action.wcReport.muns !== state.selectedEntity.muns) {
        return { ...state };
      }
      return {
        ...state,
        LoadingWc: false,
        wcReport: action.wcReport,
      };
    case WELFARE_SUMMARIES_REQUEST_STARTED:
      return {
        ...state,
        LoadingWelfareSummaries: true,
        ErrorLoadingWelfareSummaries: false,
      };
    case WELFARE_SUMMARIES_REQUEST_ERROR:
      return {
        ...state,
        LoadingWelfareSummaries: false,
        ErrorLoadingWelfareSummaries: true,
      };
    case WELFARE_SUMMARIES_FETCHED:
      // if the muns of the returned welfare summaries does not match the
      // selected entity then do not update state
      if (action.welfareSummaries.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      const welafareSummaries = action.welfareSummaries.reports;

      return {
        ...state,
        LoadingWelfareSummaries: false,
        ErrorLoadingWelfareSummaries: false,
        welfareSummaries: welafareSummaries,
      };
    case WELFARE_LOBS_REQUEST_STARTED:
      return {
        ...state,
        LoadingWelfareLinesOfBusiness: true,
        ErrorLoadingWelfareLinesOfBusiness: false,
      };
    case WELFARE_LOBS_REQUEST_ERROR:
      return {
        ...state,
        LoadingWelfareLinesOfBusiness: false,
        ErrorLoadingWelfareLinesOfBusiness: true,
      };
    case WELFARE_LOBS_FETCHED:
      // if the muns of the returned welfare lines of business does not match the
      // selected entity then do not update state
      if (action.welfareLinesOfBusiness.muns !== state.selectedEntity.muns) {
        return { ...state };
      }
      const welfareLinesOfBusiness = action.welfareLinesOfBusiness.reports;
      const numberOfLines = welfareLinesOfBusiness ? welfareLinesOfBusiness.length : 0;
      const totalPremium = sumObjectArray(welfareLinesOfBusiness, 'premium');
      const totalCommission = sumObjectArray(welfareLinesOfBusiness, 'commission');
      const totalFees = sumObjectArray(welfareLinesOfBusiness, 'fees');
      const brokers = summarizeWelfareBusinessLinesToBrokers(welfareLinesOfBusiness);
      const employers = summarizeWelfareBusinessLinesToEmployers(welfareLinesOfBusiness);
      const carriers = summarizeWelfareBusinessLinesToCarriers(welfareLinesOfBusiness);
      const linesOfBusiness = summarizeWelfareBusinessLinesToLobs(welfareLinesOfBusiness);
      const brokersNormalized =
        summarizeWelfareBusinessLinesToBrokersNormalized(welfareLinesOfBusiness);
      const carriersNormalized =
        summarizeWelfareBusinessLinesToCarriersNormalized(welfareLinesOfBusiness);
      return {
        ...state,
        LoadingWelfareLinesOfBusiness: false,
        ErrorLoadingWelfareLinesOfBusiness: false,
        welfareLinesOfBusinessReport: {
          brokers,
          employers,
          carriers,
          linesOfBusiness,
          numberOfLines,
          totalCommission,
          totalFees,
          totalPremium,
          welfareLinesOfBusiness,
          brokersNormalized,
          carriersNormalized,
        },
        welfareLinesOfBusiness: action.welfareLinesOfBusiness.reports,
      };
    case WELFARE_BROKER_SUMMARIES_REQUEST_STARTED:
      return {
        ...state,
        LoadingWelfareBrokerSummaries: true,
        ErrorLoadingWelfareBrokerSummaries: false,
      };
    case WELFARE_BROKER_SUMMARIES_REQUEST_ERROR:
      return {
        ...state,
        LoadingWelfareBrokerSummaries: false,
        ErrorLoadingWelfareBrokerSummaries: true,
      };
    case WELFARE_BROKER_SUMMARIES_FETCHED:
      // if the muns of the returned welfare lines of business does not match the
      // selected entity then do not update state
      if (action.welfareBrokerSummaries.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      return {
        ...state,
        LoadingWelfareBrokerSummaries: false,
        ErrorLoadingWelfareBrokerSummaries: false,
        welfareBrokerSummaries: action.welfareBrokerSummaries.reports,
      };
    case WELFARE_BROKER_SUMMARIES_HISTORY_REQUEST_STARTED:
      return {
        ...state,
        LoadingWelfareBrokerSummariesHistory: true,
        ErrorLoadingWelfareBrokerSummariesHistory: false,
      };
    case WELFARE_BROKER_SUMMARIES_HISTORY_REQUEST_ERROR:
      return {
        ...state,
        LoadingWelfareBrokerSummariesHistory: false,
        ErrorLoadingWelfareBrokerSummariesHistory: true,
      };
    case WELFARE_BROKER_SUMMARIES_HISTORY_FETCHED:
      // if the muns of the returned welfare broker summaries history does not match the
      // selected entity then do not update state
      if (action.welfareBrokerSummariesHistory.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      return {
        ...state,
        LoadingWelfareBrokerSummariesHistory: false,
        ErrorLoadingWelfareBrokerSummariesHistory: false,
        welfareBrokerSummariesHistory: action.welfareBrokerSummariesHistory.reports,
      };

    case WELFARE_SERVICE_PROVIDER_SUMMARIES_REQUEST_STARTED:
      return {
        ...state,
        LoadingWelfareServiceProviderSummaries: true,
        ErrorLoadingWelfareServiceProviderSummaries: false,
      };

    case WELFARE_SERVICE_PROVIDER_SUMMARIES_REQUEST_ERROR:
      return {
        ...state,
        LoadingWelfareServiceProviderSummaries: false,
        ErrorLoadingWelfareServiceProviderSummaries: true,
      };

    case WELFARE_SERVICE_PROVIDER_SUMMARIES_FETCHED:
      // if the muns of the returned welfare service providers does not match the
      // selected entity then do not update state
      if (action.welfareServiceProviderSummaries.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      return {
        ...state,
        LoadingWelfareServiceProviderSummaries: false,
        ErrorLoadingWelfareServiceProviderSummaries: false,
        welfareServiceProviderSummaries: action.welfareServiceProviderSummaries.reports,
      };

    case WELFARE_SERVICE_PROVIDERS_REQUEST_STARTED:
      return {
        ...state,
        LoadingWelfareServiceProviders: true,
        ErrorLoadingWelfareServiceProviders: false,
      };

    case WELFARE_SERVICE_PROVIDERS_REQUEST_ERROR:
      return {
        ...state,
        LoadingWelfareServiceProviders: false,
        ErrorLoadingWelfareServiceProviders: true,
      };

    case WELFARE_SERVICE_PROVIDERS_FETCHED:
      // if the muns of the returned welfare service providers does not match the
      // selected entity then do not update state
      if (action.welfareServiceProviders.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      const welfareServiceProviders = action.welfareServiceProviders.reports;
      const numberOfServices = welfareServiceProviders ? welfareServiceProviders.length : 0;
      const totalDirectCompensation = sumObjectArray(
        welfareServiceProviders,
        'direct_compensation'
      );
      const totalIndirectCompensation = sumObjectArray(
        welfareServiceProviders,
        'indirect_compensation'
      );
      const serviceProviders = summarizeWelfareServiceProvidersToProviders(welfareServiceProviders);
      const serviceEmployers = summarizeWelfareServiceProvidersToEmployers(welfareServiceProviders);
      return {
        ...state,
        LoadingWelfareServiceProviders: false,
        ErrorLoadingWelfareServiceProviders: false,
        welfareServiceProviders,
        welfareServiceProvidersReport: {
          serviceEmployers,
          numberOfServices,
          serviceProviders,
          totalDirectCompensation,
          totalIndirectCompensation,
          welfareServiceProviders,
        },
      };

    case RETIREMENT_SUMMARIES_REQUEST_STARTED:
      return {
        ...state,
        LoadingRetirementSummaries: true,
        ErrorLoadingRetirementSummaries: false,
      };
    case RETIREMENT_SUMMARIES_REQUEST_ERROR:
      return {
        ...state,
        LoadingRetirementSummaries: false,
        ErrorLoadingRetirementSummaries: true,
      };
    case RETIREMENT_SUMMARIES_FETCHED:
      // if the muns of the returned welfare lines of business does not match the
      // selected entity then do not update state
      if (action.retirementSummaries.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      return {
        ...state,
        LoadingRetirementSummaries: false,
        ErrorLoadingRetirementSummaries: false,
        retirementSummaries: action.retirementSummaries.reports,
      };
    case RETIREMENT_PLANS_REQUEST_STARTED:
      return {
        ...state,
        LoadingRetirementPlans: true,
        ErrorLoadingRetirementPlans: false,
      };
    case RETIREMENT_PLANS_REQUEST_ERROR:
      return {
        ...state,
        LoadingRetirementPlans: false,
        ErrorLoadingRetirementPlans: true,
      };
    case RETIREMENT_PLANS_FETCHED:
      // if the muns of the returned welfare lines of business does not match the
      // selected entity then do not update state
      if (action.retirementPlans.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      const retirementPlans = action.retirementPlans.reports;
      const numberOfPlans = retirementPlans ? retirementPlans.length : 0;
      const totalAssetsBeginningOfYear = sumObjectArray(retirementPlans, 'assets_boy');
      const totalAssetsEndOfYear = sumObjectArray(retirementPlans, 'assets_eoy');
      const retirementPlanSponsors = summarizeRetirementPlansToSponsors(retirementPlans);

      return {
        ...state,
        LoadingRetirementPlans: false,
        ErrorLoadingRetirementPlans: false,
        retirementPlans,
        retirementPlansReport: {
          numberOfPlans,
          retirementPlans,
          retirementPlanSponsors,
          totalAssetsBeginningOfYear,
          totalAssetsEndOfYear,
        },
      };
    case RETIREMENT_PLANS_HISTORY_REQUEST_STARTED:
      return {
        ...state,
        LoadingRetirementPlansHistory: true,
        ErrorLoadingRetirementPlansHistory: false,
      };
    case RETIREMENT_PLANS_HISTORY_REQUEST_ERROR:
      return {
        ...state,
        LoadingRetirementPlansHistory: false,
        ErrorLoadingRetirementPlansHistory: true,
      };
    case RETIREMENT_PLANS_HISTORY_FETCHED:
      // if the muns of the returned welfare lines of business does not match the
      // selected entity then do not update state
      if (action.retirementPlansHistory.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      // Default reports to an empty array
      let historyReports = [];
      if (action.retirementPlansHistory.reports) {
        historyReports = action.retirementPlansHistory.reports;
      }

      return {
        ...state,
        LoadingRetirementPlansHistory: false,
        ErrorLoadingRetirementPlansHistory: false,
        retirementPlansHistory: historyReports,
      };
    case RETIREMENT_PROVIDER_SUMMARIES_REQUEST_STARTED:
      return {
        ...state,
        LoadingRetirementProviderSummaries: true,
        ErrorLoadingRetirementProviderSummaries: false,
      };
    case RETIREMENT_PROVIDER_SUMMARIES_FETCHED:
      // if the muns of the returned welfare lines of business does not match the
      // selected entity then do not update state
      if (action.retirementProviderSummaries.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      return {
        ...state,
        LoadingRetirementProviderSummaries: false,
        ErrorLoadingRetirementProviderSummaries: false,
        retirementProviderSummaries: action.retirementProviderSummaries.reports,
      };
    case RETIREMENT_PROVIDER_SUMMARIES_REQUEST_ERROR:
      return {
        ...state,
        LoadingRetirementProviderSummaries: false,
        ErrorLoadingRetirementProviderSummaries: true,
      };
    case RETIREMENT_SERVICE_PROVIDERS_REQUEST_STARTED:
      return {
        ...state,
        LoadingRetirementServiceProviders: true,
        ErrorLoadingRetirementServiceProviders: false,
      };
    case RETIREMENT_SERVICE_PROVIDERS_FETCHED:
      // if the muns of the returned welfare lines of business does not match the
      // selected entity then do not update state
      if (action.retirementServiceProviders.muns !== state.selectedEntity.muns) {
        return { ...state };
      }
      const retirementServiceProviders = action.retirementServiceProviders.reports;
      const numberOfRetirementServices = retirementServiceProviders
        ? retirementServiceProviders.length
        : 0;
      const totalDirectRetirementServicesCompensation = sumObjectArray(
        retirementServiceProviders,
        'direct_compensation'
      );
      const totalIndirectRetirementServicesCompensation = sumObjectArray(
        retirementServiceProviders,
        'indirect_compensation'
      );
      const retirementServiceProviderSponsors = summarizeRetirementServiceProvidersToSponsors(
        retirementServiceProviders
      );

      return {
        ...state,
        LoadingRetirementServiceProviders: false,
        ErrorLoadingRetirementServiceProviders: false,
        retirementServiceProviders,
        retirementServiceProvidersReport: {
          numberOfRetirementServices,
          retirementServiceProviders,
          retirementServiceProviderSponsors,
          totalIndirectRetirementServicesCompensation,
          totalDirectRetirementServicesCompensation,
        },
      };
    case RETIREMENT_SERVICE_PROVIDERS_REQUEST_ERROR:
      return {
        ...state,
        LoadingRetirementServiceProviders: false,
        ErrorLoadingRetirementServiceProviders: true,
      };
    case OSHA_REPORT_REQUEST_STARTED:
      return {
        ...state,
        LoadingOsha: true,
        ErrorLoadingOsha: false,
      };
    case OSHA_REPORT_REQUEST_ERROR:
      return {
        ...state,
        LoadingOsha: false,
        ErrorLoadingOsha: true,
      };
    case OSHA_REPORT_FETCHED:
      // if the muns of the returned welfare lines of business does not match the
      // selected entity then do not update state
      if (action.oshaReport.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      return {
        ...state,
        LoadingOsha: false,
        ErrorLoadingOsha: false,
        oshaReport: action.oshaReport,
      };
    case PROPERTY_REPORT_REQUEST_STARTED:
      return {
        ...state,
        LoadingProperty: true,
        ErrorLoadingProperty: false,
      };
    case PROPERTY_REPORT_REQUEST_ERROR:
      return {
        ...state,
        LoadingProperty: false,
        ErrorLoadingProperty: true,
      };
    case PROPERTY_REPORT_FETCHED:
      // if the address of the returned property report does not match the
      // selected entity then do not update state

      if (action.propertyReport && action.propertyReport.muns !== state.selectedEntity.muns) {
        return { ...state };
      }
      return {
        ...state,
        LoadingProperty: false,
        ErrorLoadingProperty: false,
        propertyReport: action.propertyReport,
      };
    case FULL_PROPERTY_REPORT_REQUEST_STARTED:
      return {
        ...state,
        LoadingFullProperty: true,
        ErrorLoadingFullProperty: false,
      };
    case FULL_PROPERTY_REPORT_REQUEST_ERROR:
      return {
        ...state,
        LoadingFullProperty: false,
        ErrorLoadingFullProperty: true,
      };
    case FULL_PROPERTY_REPORT_FETCHED:
      // if the address of the returned property report does not match the
      // selected entity then do not update state

      if (
        action.fullPropertyReport &&
        action.fullPropertyReport.muns !== state.selectedEntity.muns
      ) {
        return { ...state };
      }
      return {
        ...state,
        LoadingFullProperty: false,
        ErrorLoadingFullProperty: false,
        fullPropertyReport: action.fullPropertyReport,
      };
    case WHD_REPORT_REQUEST_STARTED:
      return {
        ...state,
        LoadingWhd: true,
        ErrorLoadingWhd: false,
      };
    case WHD_REPORT_REQUEST_ERROR:
      return {
        ...state,
        LoadingWhd: false,
        ErrorLoadingWhd: true,
      };
    case WHD_REPORT_FETCHED:
      // if the muns of the returned WHD report does not match the
      // selected entity then do not update state
      if (action.whdReport.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      return {
        ...state,
        LoadingWhd: false,
        ErrorLoadingWhd: false,
        whdReport: action.whdReport.report,
      };
    case USER_NOTES_REQUEST_STARTED:
      return {
        ...state,
        LoadingUserNotes: true,
        ErrorLoadingUserNotes: false,
      };
    case USER_NOTES_REQUEST_ERROR:
      return {
        ...state,
        LoadingUserNotes: false,
        ErrorLoadingUserNotes: true,
      };
    case USER_NOTES_FETCHED:
      // if the muns of the returned welfare summaries does not match the
      // selected entity then do not update state
      if (action.userNotes.muns !== state.selectedEntity.muns) {
        return { ...state };
      }

      return {
        ...state,
        LoadingUserNotes: false,
        ErrorLoadingUserNotes: false,
        userNotes: action.userNotes,
      };
    case WELFARE_FILINGS_REQUEST_STARTED:
      return {
        ...state,
        LoadingWelfareFilings: true,
        ErrorLoadingWelfareFilings: false,
      };
    case WELFARE_FILINGS_REQUEST_ERROR:
      return {
        ...state,
        LoadingWelfareFilings: false,
        ErrorLoadingWelfareFilings: true,
      };
    case WELFARE_FILINGS_FETCHED:
      // if the muns of the returned welfare summaries does not match the
      // selected entity then do not update state
      if (action.welfareFilingsReport.msid !== state.selectedEntity.muns) {
        return { ...state };
      }
      return {
        ...state,
        LoadingWelfareFilings: false,
        ErrorLoadingWelfareFilings: false,
        welfareFilingsReport: action.welfareFilingsReport,
      };
    // Retirement Filings
    case RETIREMENT_FILINGS_REQUEST_STARTED:
      return {
        ...state,
        LoadingRetirementFilings: true,
        ErrorLoadingRetirementFilings: false,
      };
    case RETIREMENT_FILINGS_REQUEST_ERROR:
      return {
        ...state,
        LoadingRetirementFilings: false,
        ErrorLoadingRetirementFilings: true,
      };
    case RETIREMENT_FILINGS_FETCHED:
      // if the muns of the returned welfare summaries does not match the
      // selected entity then do not update state
      if (action.retirementFilingsReport.msid !== state.selectedEntity.muns) {
        return { ...state };
      }
      return {
        ...state,
        LoadingRetirementFilings: false,
        ErrorLoadingRetirementFilings: false,
        retirementFilingsReport: action.retirementFilingsReport,
      };
    case DUP_AMS_ACCOUNTS_REQUEST_STARTED:
      return {
        ...state,
        LoadingDupAmsAccounts: true,
        ErrorLoadingDupAmsAccounts: false,
      };
    case DUP_AMS_ACCOUNTS_REQUEST_ERROR:
      return {
        ...state,
        dupAmsAccounts: null,
        LoadingDupAmsAccounts: false,
        ErrorLoadingDupAmsAccounts: true,
      };
    case DUP_AMS_ACCOUNTS_FETCHED:
      // if the muns of the returned welfare summaries does not match the
      // selected entity then do not update state
      if (action.dupAmsAccounts.muns !== state.selectedEntity.muns) {
        return { ...state };
      }
      return {
        ...state,
        LoadingDupAmsAccounts: false,
        ErrorLoadingDupAmsAccounts: false,
        dupAmsAccounts: action.dupAmsAccounts,
      };
    case LAUNCH_DARKLY_REQUEST_STARTED:
      return {
        ...state,
        LoadingLaunchDarkly: true,
        ErrorLoadingLaunchDarkly: false,
      };
    case LAUNCH_DARKLY_REQUEST_ERROR:
      return {
        ...state,
        launchDarkly: null,
        LoadingLaunchDarkly: false,
        ErrorLoadingLaunchDarkly: true,
      };
    case LAUNCH_DARKLY_FETCHED:
      return {
        ...state,
        LoadingLaunchDarkly: false,
        ErrorLoadingLaunchDarkly: false,
        launchDarkly: action.launchDarkly,
      };

    default:
      return state;
  }
}

export default EntityDetails;
